import './editEmailOtpStep.scss';
// @ vendors
import React, { useState, useEffect } from 'react';

// @commons
import { i18n } from 'core/i18n';
const { FormattedText, formatText } = i18n;
import { InputSafe } from 'commonsComponents/inputSafe';
import { LoadingSection } from 'commonsComponents/loadingSection';
import { OKMessage } from 'commonsComponents/OKMessage';
import { OKButton } from 'commonsComponents/OKButton';

import {
  starOtpEmailAuthLink, 
  otpClickTextBoxLink,
  requestNewOtpLink,
  errorRequiredFieldOTPLink,
  errorIncorrectOTPLink,
  maxRequestsNumberErrorLink,
  expiredCodeErrorLink,
  maxAttemptsOTPErrorLink,
} from 'utilities/taggingInfo/profileEditorViewTagging';

// @constants
import { VERIFY_OTP_MAX_ATTEMPTS_CODE, REQUEST_CODE_TOP , BAD_REQUEST_CODE, EXPIRED_REQUEST_CODE } from 'constants/index';

function EditEmailOtpStep({ immProfileEditor, onHandleSetOtp, resendOtpEmail }) {
  const [blurError, setBlurError] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const immStep = immProfileEditor.getIn(['steps', 0])
  const newEmail = immStep.get('repeatEmail');
  const { requestOtpErrorStatus, isOtpEmailFetching, verifyOtpErrorStatus } = immProfileEditor.toJS();

  useEffect(() => {
    starOtpEmailAuthLink()
  }, [])

  const expiredMessage = <OKMessage type="warning">
      <p><FormattedText value='profileEditForm-otp_email_error_expired' /></p>
    </OKMessage>;

  const blockedMessage = <OKMessage type="warning">
      <p><FormattedText value='profileEditForm-otp_email_error_blocked' /></p>
    </OKMessage>;

 const maxRequestTop = <OKMessage type="important">
      <p><FormattedText value='profileEditForm-otp_email_new_request_top' /></p>
    </OKMessage>;

  function resendOtopLink() {
    requestNewOtpLink();
    resendOtpEmail(formatText('profileEditForm-otp_email_new_request_sent'));
  }

  function buildLink() {
    return (
      <p className='text-info'>
        <span>{formatText('profileEditForm-otp_email_new_request')}</span>
            <OKButton
                onClick={resendOtopLink}
                modifier="link-emphasize"
                autoHeight={true}
                loading={false}
                disabled={requestOtpErrorStatus === REQUEST_CODE_TOP || verifyOtpErrorStatus === VERIFY_OTP_MAX_ATTEMPTS_CODE}
            >
              {formatText('profileEditForm-otp_email_new_code_link')}
            </OKButton>
        <span>{formatText('profileEditForm-otp_email_phone')}</span>
      </p>)
    }

  function handleBlurError() {
    setBlurError(inputValue === '');
  }

  function handleChange(e) {
    setBlurError(false);
    setInputValue(e.target.value);
    onHandleSetOtp(e.target.value)
  }

  function showErrorInput() {
    const hasError = verifyOtpErrorStatus === BAD_REQUEST_CODE || blurError;
    if(hasError) {
      blurError ? errorRequiredFieldOTPLink(formatText('profileEditForm-otp_email_error_empty')) : errorIncorrectOTPLink(formatText('profileEditForm-otp_email_error'));
    }
    return hasError;
  }

  function showVerifyOtpError() {
    let errorMessage = '';
    
    if(verifyOtpErrorStatus) {
      if (verifyOtpErrorStatus === EXPIRED_REQUEST_CODE) {
        expiredCodeErrorLink();
        errorMessage = expiredMessage;
      } else if(verifyOtpErrorStatus === VERIFY_OTP_MAX_ATTEMPTS_CODE) {
        maxAttemptsOTPErrorLink();
        errorMessage = blockedMessage;
      }
    } else {
      if(requestOtpErrorStatus === REQUEST_CODE_TOP) {
        maxRequestsNumberErrorLink();
        errorMessage = maxRequestTop;
      }
    }

    return errorMessage;
  }

  function getOtpInputError() {
    return blurError ? <FormattedText value="profileEditForm-otp_email_error_empty" /> : <FormattedText value="profileEditForm-otp_email_error" />;
  }

  return (
    <div className='row edit-otpEmail-container'>
      <div className="col-xs-12">
        <h4 className='title'><FormattedText value="profileEditForm-otp_email_validate_address"/></h4>
        <p className='text-space-bottom'><strong><FormattedText value="profileEditForm-otp_email_copy" /></strong></p>
        <p><FormattedText value="profileEditForm-newEmail"/></p>
        <p><strong>{ newEmail }</strong></p>
      </div>
      {
        isOtpEmailFetching ? 
          <LoadingSection />
        :  
          <div className="col-xs-12 verify-box">
            <hr className='line' />
            <p className='verify-title'><FormattedText value="profileEditForm-otp_email_validation_code" /></p>
            <InputSafe
                label={formatText('profileEditForm-otp_email_subtitle')}
                name="emailOtp"
                type="text"
                onChange={handleChange}
                onClick={otpClickTextBoxLink}
                errorState={showErrorInput()}
                errorMessage={getOtpInputError()}
                onBlur={handleBlurError}
                disabled={verifyOtpErrorStatus === VERIFY_OTP_MAX_ATTEMPTS_CODE || requestOtpErrorStatus === VERIFY_OTP_MAX_ATTEMPTS_CODE}
            />
            {buildLink()}
            {showVerifyOtpError()}
          </div>
      }
    </div>
  );
}

export default EditEmailOtpStep;